// extracted by mini-css-extract-plugin
export default {"access-management-user-form-instance-table-row__edit-cell":"AccessManagementUserFormInstanceTableRow_access-management-user-form-instance-table-row__edit-cell__l5RKq"};